// extracted by mini-css-extract-plugin
module.exports = {"content":"CookiePolicy_content__3ba4C"};